import script from "./SubscriptionPlanCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubscriptionPlanCard.vue?vue&type=script&lang=ts&setup=true"

import "./SubscriptionPlanCard.vue?vue&type=style&index=0&id=4fe8e14d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fe8e14d"]])

export default __exports__